export const STREAM_QUALITY_OPTIONS = [480, 720, 1080];

export const isStreamTypeRestreamable = (type) => type === 'stream';

export const buildRestreamParams = (quality) => (
  quality === undefined ? undefined : { quality }
);

// LP error 11078: ретранслятор выключен на стенде/инсталляции —
// повторные попытки бессмысленны, ретраить не нужно.
// Ошибка приходит либо как axios-объект (response.data), либо как LunaError (плоские поля)
export const isRetranslatorDisabledError = (error) => (
  error?.error_code === 11078
  || error?.response?.data?.error_code === 11078
);
